export default "__VITE_ASSET__0b1ee061__"